import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-menu-link',
  templateUrl: './menu-link.component.html',
  styleUrl: './menu-link.component.scss',
})
export class MenuLinkComponent {
  @Input({ required: true }) title!: string;
  @Input() icon = 'big-arrow-right.svg';
  @Output() goToPage = new EventEmitter<void>();
}
